import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from 'tmt-ui-kit';

const RedIcon = styled(Icon)`
  color: #fe4545;
`;

const GreenIcon = styled(Icon)`
  color: ${props => props.theme.greenLighter};
`;

const VoteContaienr = styled.div`
  color: ${props => props.theme.black} !important;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const VoteOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const VerticalBar = styled.div`
  height: 24px;
  width: 1px;
  opacity: 0.5;
  background-color: ${props => props.theme.black} !important;
`;

const VoteBlock = styled.div`
  margin-right: 8px;
  opacity: 0.4;
  :last-child {
    margin-right: 0px;
  }
`;

const RotatedContainer = styled.div`
  margin-top: -2px;
  transform: rotate(180deg);
`;

const Clickable = styled.button`
  background-color: transparent;
  color: inherit;
  border: none;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
`;

class ReviewVote extends Component {
  state = {
    vote: 0,
    isVoted: false
  };

  handleVote = vote => {
    this.setState({
      vote,
      isVoted: true,
    });
    this.props.handleVote(vote);
  }

  render() {
    const vote = this.state.isVoted ? this.state.vote : this.props.vote;
    return (
      <VoteContaienr>
        {!vote && (
          <VoteOptionContainer>
            <VoteBlock>Helpful?</VoteBlock>
            <VoteBlock>
              <Clickable onClick={() => this.handleVote(1)}>
                <Icon name="like" />
              </Clickable>
            </VoteBlock>
            <VoteBlock><VerticalBar /></VoteBlock>
            <VoteBlock>
              <Clickable onClick={() => this.handleVote(-1)}>
                <RotatedContainer><Icon name="like" /></RotatedContainer>
              </Clickable>
            </VoteBlock>
          </VoteOptionContainer>
        )}
        {(vote === -1 || vote === 1) && (
          <VoteOptionContainer>
            <Clickable onClick={() => this.handleVote(0)}>
              {vote === -1 && <RotatedContainer><RedIcon name="like-select" /></RotatedContainer>}
              {vote === 1 && <GreenIcon name="like-select" />}
            </Clickable>
            <VoteBlock>Thanks for Feedback!</VoteBlock>
          </VoteOptionContainer>
        )}
      </VoteContaienr>
    );
  }
}

ReviewVote.propTypes = {
  handleVote: PropTypes.func,
  vote: PropTypes.number,
};

export default ReviewVote;
